import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TabPanel} from 'primeng/tabs';
import {LoadingComponent} from '../../components/loading/loading.component';

@Component({
  selector: 'app-tab-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingComponent, TabPanel],
  templateUrl: './tab-panel.component.html',
  host: {class: 'contents'},
})
export class TabPanelComponent {
  readonly value = input.required<string | number>();
  readonly loading = input<boolean>(false);
}
